import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_ENDPOINTS } from '../../../core/providers/constants/api.constants';
import { SchedulingApiRoutesDto } from '../dto/scheduling.dto';
import { WorkOrderPackingLabel } from '../types/report';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteSchedulingSubOrderService extends IApiBackendRouteService {
  constructor(protected readonly http: HttpClient) {
    super();
  }

  urlRoute = `${API_ENDPOINTS.SCHEDULER_PROCESS}/sub-work-order`;

  registerProgressSubWorkOrder(
    body: SchedulingApiRoutesDto['registerProgress']['body']
  ): Observable<any> {
    return this.http.post(`${this.urlRoute}/register-progress`, body);
  }

  registerProgressStage(
    body: SchedulingApiRoutesDto['registerStageProgress']['body']
  ): Observable<any> {
    return this.http.post(`${this.urlRoute}/finish-stage`, body);
  }

  setAsNotRunning(machineId: number, itemId: number): Observable<any> {
    return this.http.patch(`${this.urlRoute}/not-running`, {
      itemId,
      machineId,
    });
  }

  getPackingLabel(reportId: number): Observable<WorkOrderPackingLabel> {
    return this.http.get<WorkOrderPackingLabel>(
      `${this.urlRoute}/packing-report?reportId=${reportId}`
    );
  }
}
